// UUIDv7 (RFC 9562): 48-bit Unix ms timestamp, version 7, 74 random bits.

/** Deterministic form for tests: `random` supplies 10 bytes (only 74 bits are used). */
export function uuidv7(ms: number, random: Uint8Array): string {
  if (random.length !== 10) throw new Error('uuidv7 needs 10 random bytes');
  const r = (i: number) => random[i] as number;
  const b = new Uint8Array(16);
  for (let i = 0; i < 6; i++) b[i] = Math.floor(ms / 2 ** (8 * (5 - i))) & 0xff;
  b[6] = 0x70 | (r(0) & 0x0f);
  b[7] = r(1);
  b[8] = 0x80 | (r(2) & 0x3f);
  for (let i = 3; i < 10; i++) b[i + 6] = r(i);
  const hex = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function newUuidv7(now = Date.now()): string {
  return uuidv7(now, crypto.getRandomValues(new Uint8Array(10)));
}

export function uuidv7Timestamp(id: string): number {
  return Number.parseInt(id.replaceAll('-', '').slice(0, 12), 16);
}
